import React, {useState} from 'react';
import BottomNavigation from 'reactjs-bottom-navigation';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

import 'reactjs-bottom-navigation/dist/index.css';


interface IProps {
    history:any;
    currentTab:number;
}

const BottomNav = (props:IProps) => {
    
    const [currentTab, setCurrentTab] = useState(0);
    const bottomNavItems = [
        {
          title: 'Home',
          icon: <i className="ti-home" style={{fontSize:"22px"}}></i>,
          activeIcon: <i className="ti-home" style={{fontSize:"22px"}}></i>,
          onClick: () => props.history.push('/')
        },
        {
          title: 'Classes',  
          icon: <i className="ti-calendar" style={{fontSize:"22px"}}></i>,
          activeIcon: <i className="ti-calendar" style={{fontSize:"22px"}}></i>,
          onClick: () => props.history.push('/teachers/classesmobile')
        },
        {
          title: 'Courses',
          icon: <i className="ti-blackboard" style={{fontSize:"26px"}}></i>,
          activeIcon: <i className="ti-blackboard" style={{fontSize:"26px"}}></i>,
          onClick: () => props.history.push('/teachers/coursesmobile')
        },
        {
          title: 'Students',
          icon: <i className="ti-user" style={{fontSize:"22px"}}></i>,
          activeIcon: <i className="ti-user" style={{fontSize:"22px"}}></i>,
          onClick: () => props.history.push('/teachers/StudentsMobile')
        }
    ]
    return(
        <>{isMobile && 
        <BottomNavigation
            items={bottomNavItems}
            defaultSelected={props.currentTab}
            //onItemClick={(item) => setCurrentTab(item.id)}
        />}
        </>
    );
}

export default BottomNav;